define('AwaLabs.FacetsAliasesFix', [
    'Backbone',
    'Facets.Router',
    'underscore'
], function AwaLabsFacetsAliasesFix(
    Backbone,
    FacetsRouter,
    _
) {
    'use strict';

    _.extend(FacetsRouter.prototype, {
        unaliasUrl: _.wrap(FacetsRouter.prototype.unaliasUrl, function unaliasUrlFix(fn, aliasedUrl, corrections) {
            var newAliasedUrl = aliasedUrl || Backbone.history.fragment;
            return fn.apply(this, [newAliasedUrl, corrections]);
        })
    });
});
